import $ from 'jquery'

export default {
	init() {
		const $form = $('#pdf-meni-form')
		if ($form.length === 0) return

		const formEl = $form.get(0)
		const action = $form.find('input[name="action"]').val()
		if (action !== 'tr_pdf_meni') return

		const getErrorMessage = (payload, fallback = 'Napaka pri shranjevanju. Osvežite stran in poskusite znova.') => {
			if (typeof payload === 'string' && payload.trim() !== '') return payload
			if (payload && typeof payload === 'object') {
				if (typeof payload.error === 'string' && payload.error.trim() !== '') return payload.error
				if (typeof payload.message === 'string' && payload.message.trim() !== '') return payload.message
			}
			return fallback
		}

		const getFilenameFromUrl = (url) => {
			try {
				const parsed = new URL(url, window.location.href)
				const file = decodeURIComponent((parsed.pathname || '').split('/').pop() || '')
				return file || 'tr-menu.pdf'
			} catch (_) {
				return 'tr-menu.pdf'
			}
		}

		const openPdfInNewTab = (url) => {
			if (!url) return
			window.open(url, '_blank', 'noopener')
		}

		const downloadPdfToComputer = (url) => {
			if (!url || typeof fetch !== 'function') return

			const filename = getFilenameFromUrl(url)
			fetch(url, { credentials: 'same-origin' })
				.then((response) => {
					if (!response.ok) throw new Error('PDF fetch failed')
					return response.blob()
				})
				.then((blob) => {
					const objectUrl = window.URL.createObjectURL(blob)
					const link = document.createElement('a')
					link.href = objectUrl
					link.download = filename
					document.body.appendChild(link)
					link.click()
					link.remove()
					window.URL.revokeObjectURL(objectUrl)
				})
				.catch(() => {})
		}

		$form.on('submit', function(e) {
			e.preventDefault()

			if (formEl && !formEl.checkValidity()) {
				formEl.reportValidity()
				return
			}

			const $submitBtn = $form.find('button[type="submit"]')
			const form_error_element = $form.find('.form-response.error')
			$submitBtn.prop('disabled', true)
			form_error_element
				.addClass('hidden')
				.removeClass('success text-blue border-blue')
				.addClass('text-red border-red')

			const saveAlergeniData = new FormData(this)
			saveAlergeniData.set('action', 'tr_save_alergene')

			$.ajax({
				url: my_ajax_object.ajax_url,
				type: 'POST',
				data: saveAlergeniData,
				processData: false,
				contentType: false,
				dataType: 'json',
				success: function (saveResponse) {
					if (!saveResponse || !saveResponse.success) {
						const msg = getErrorMessage(saveResponse?.data, 'Napaka pri shranjevanju alergenov.')
						form_error_element.text(msg).removeClass('hidden').show()
						$submitBtn.prop('disabled', false)
						return
					}

					const generatePdfData = new FormData(formEl)
					generatePdfData.set('action', 'tr_pdf_meni')

					$.ajax({
						url: my_ajax_object.ajax_url,
						type: 'POST',
						data: generatePdfData,
						processData: false,
						contentType: false,
						dataType: 'json',
						success: function (pdfResponse) {
							if (!pdfResponse || !pdfResponse.success) {
								const msg = getErrorMessage(pdfResponse?.data, 'Napaka pri generiranju PDF menija.')
								form_error_element.text(msg).removeClass('hidden').show()
								return
							}

							const pdfUrl = pdfResponse?.data?.pdf_menu_url || ''
							if (!pdfUrl) {
								form_error_element.text('PDF meni je bil generiran, vendar URL ni na voljo.').removeClass('hidden').show()
								return
							}

							openPdfInNewTab(pdfUrl)
							downloadPdfToComputer(pdfUrl)
							form_error_element
								.text('Alergeni so shranjeni. PDF meni se odpira in prenaša.')
								.removeClass('hidden text-red border-red')
								.addClass('success text-blue border-blue')
								.show()
						},
						error: function (jqXHR) {
							const msg = getErrorMessage(jqXHR?.responseJSON?.data, 'Napaka pri generiranju PDF menija.')
							form_error_element.text(msg).removeClass('hidden').show()
						},
						complete: function () {
							$submitBtn.prop('disabled', false)
						}
					})
				},
				error: function (jqXHR) {
					const msg = getErrorMessage(jqXHR?.responseJSON?.data, 'Napaka pri shranjevanju alergenov.')
					form_error_element.text(msg).removeClass('hidden').show()
					$submitBtn.prop('disabled', false)
				}
			})
		})
	}
}
